var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "632.86pt",
    height: "228.48pt",
    viewBox: "0 0 632.86 228.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 219 65 L 356 65 L 356 228.480469 L 219 228.480469 Z M 219 65 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 374 0 L 632.859375 0 L 632.859375 98 L 374 98 Z M 374 0 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.799194%,50.999451%,75.299072%)",
      fillOpacity: 1
    },
    d: "M 246.574219 103.351563 L 221.300781 200.679688 C 221.308594 200.660156 219.273438 206.449219 219.273438 212.789063 C 219.273438 216.457031 219.949219 220.351563 222.230469 223.394531 C 224.5 226.4375 228.390625 228.480469 234.328125 228.480469 L 234.386719 228.480469 L 287.734375 228.476563 L 287.738281 228.476563 C 290.921875 228.476563 292.832031 228.480469 292.832031 228.480469 L 292.832031 228.183594 C 315.84375 225.554688 318.660156 205.351563 318.6875 205.273438 L 355.011719 65.402344 C 348.457031 66.015625 277.527344 73.210938 251.496094 98.929688 C 249.890625 100.519531 248.246094 101.980469 246.574219 103.351563 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.099915%,22.399902%,51.799011%)",
      fillOpacity: 1
    },
    d: "M 366.796875 15.679688 C 366.796875 12.011719 366.121094 8.113281 363.84375 5.078125 C 361.5625 2.023438 357.660156 -0.015625 351.6875 -0.00390625 L 293.246094 -0.00390625 L 293.246094 0.285156 C 270.234375 2.914063 267.414063 23.121094 267.390625 23.199219 L 258.609375 57.015625 C 272.449219 49.070313 285.820313 41.621094 304.058594 41.621094 C 339.535156 41.621094 353.007813 61.144531 355.183594 64.730469 L 364.777344 27.785156 C 364.769531 27.808594 366.789063 22.019531 366.796875 15.679688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.099915%,22.399902%,51.799011%)",
      fillOpacity: 1
    },
    d: "M 201.386719 75.804688 C 216.226563 75.804688 228.042969 72.371094 238.507813 67.691406 L 248.921875 27.585938 C 248.921875 27.585938 258.234375 0.824219 236.632813 0.824219 L 78.238281 0.824219 C 51.121094 0.824219 48.105469 23.308594 48.105469 23.308594 L 31.722656 86.414063 C 38.136719 80.53125 62.972656 60.367188 102.070313 60.367188 C 147.824219 60.367188 154.515625 75.804688 201.386719 75.804688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.799194%,50.999451%,75.299072%)",
      fillOpacity: 1
    },
    d: "M 174.605469 119.90625 C 132.203125 119.90625 79.746094 85.726563 58.546875 85.726563 C 50.09375 85.726563 35.707031 87.367188 31.339844 87.890625 L 2 200.894531 C 2 200.894531 -7.320313 227.652344 14.285156 227.652344 L 65.753906 227.652344 C 92.867188 227.652344 95.886719 205.164063 95.886719 205.164063 L 106.984375 162.414063 L 213.914063 162.398438 L 226.234375 114.960938 C 204.765625 122.9375 183.34375 119.90625 174.605469 119.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 304.058594 41.621094 C 285.820313 41.621094 272.449219 49.070313 258.605469 57.015625 L 246.578125 103.347656 C 248.246094 101.980469 249.890625 100.519531 251.496094 98.929688 C 277.527344 73.210938 348.457031 66.015625 355.007813 65.398438 L 355.183594 64.730469 C 353.007813 61.144531 339.535156 41.621094 304.058594 41.621094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 201.386719 75.804688 C 154.515625 75.804688 147.824219 60.367188 102.070313 60.367188 C 62.972656 60.367188 38.136719 80.53125 31.722656 86.414063 L 31.339844 87.890625 C 35.707031 87.367188 50.097656 85.726563 58.546875 85.726563 C 79.746094 85.726563 132.203125 119.90625 174.605469 119.90625 C 183.34375 119.90625 204.761719 122.9375 226.234375 114.957031 L 238.507813 67.691406 C 228.042969 72.371094 216.226563 75.804688 201.386719 75.804688 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.099915%,22.399902%,51.799011%)",
      fillOpacity: 1
    },
    d: "M 618.570313 0.824219 L 560.128906 0.824219 C 560.128906 0.824219 544.597656 -0.308594 540.15625 16.792969 L 524.148438 78.4375 L 460.8125 15.097656 C 460.8125 15.097656 446.507813 0.824219 427.675781 0.824219 L 420.265625 0.824219 C 393.148438 0.824219 390.132813 23.308594 390.132813 23.308594 L 374.757813 82.53125 C 381.144531 75.09375 394.089844 64.777344 416.886719 64.777344 C 445.371094 64.777344 500.6875 97.304688 555.460938 97.304688 C 595.148438 97.304688 611.820313 84.285156 618.003906 77.109375 L 630.859375 27.585938 C 630.859375 27.585938 640.175781 0.824219 618.570313 0.824219 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.799194%,50.999451%,75.299072%)",
      fillOpacity: 1
    },
    d: "M 530.265625 135.347656 C 463.992188 135.347656 421.269531 84.074219 394.980469 84.074219 C 383.453125 84.074219 377.164063 85.210938 373.730469 86.484375 L 344.027344 200.894531 C 344.027344 200.894531 334.703125 227.652344 356.3125 227.652344 L 408.152344 227.652344 C 435.269531 227.652344 438.285156 205.164063 438.285156 205.164063 L 455.667969 138.214844 L 523.050781 223.558594 C 523.050781 223.558594 526.257813 227.652344 531.871094 227.652344 L 554.617188 227.652344 C 581.734375 227.652344 584.753906 205.164063 584.753906 205.164063 L 616.953125 81.132813 C 607.453125 98.347656 581.128906 135.347656 530.265625 135.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 369.628906 89.984375 C 369.628906 89.984375 369.960938 89.300781 370.59375 88.238281 C 369.527344 89.214844 369.628906 89.984375 369.628906 89.984375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 555.460938 97.304688 C 500.6875 97.304688 445.371094 64.777344 416.886719 64.777344 C 394.089844 64.777344 381.144531 75.097656 374.761719 82.53125 L 373.734375 86.484375 C 377.164063 85.210938 383.453125 84.074219 394.984375 84.074219 C 421.273438 84.074219 463.992188 135.347656 530.265625 135.347656 C 581.128906 135.347656 607.449219 98.347656 616.953125 81.132813 L 618.003906 77.109375 C 611.820313 84.285156 595.148438 97.304688 555.460938 97.304688 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFin);
export default __webpack_public_path__ + "static/media/Fin.7324d6cf61ca88ea70cbfddf8f76170e.svg";
export { ForwardRef as ReactComponent };